const roles = {
  AnyAdmin: 'admin',
  Superuser: 'admin.superuser',
  Identity: 'admin.identity',
  Users: 'admin.identity.users',
  AdminAdminAccess: 'admin.identity.admin-access',
  Groups: 'admin.identity.groups',
  SystemLogs: 'admin.system.logs',
  SystemFeaturesView: 'admin.system.features',
  SystemFeaturesModify: 'admin.system.features.modify',
  SystemApi: 'admin.system.api-call',
  Payment: 'admin.payment',
  PaymentSupport: 'admin.payment.support',
  PaymentView: 'admin.payment.view',
  ViewPaymentLocation: 'admin.payment.location',
  PaymentCredit: 'admin.payment.add-credit',
  PaymentDeleteBanks: 'admin.payment.delete',
  PaymentRunBilling: 'admin.payment.bill',
  PaymentReissueWex: 'admin.payment.wex-reissue',
  PaymentRefund: 'admin.payment.refund',
  PaymentCoupons: 'admin.payment.coupons',
  PaymentReconciliation: 'admin.payment.reconciliation',
  RecordReturnedCards: 'admin.payment.rts',
  Dwolla: 'admin.payment.dwolla',
  Queues: 'admin.system.queues',
  POI: 'admin.poi',
  Designer: 'admin.designer',
  BusinessPagesAdmin: 'bp.administrator',
  GasBackCampaigns: 'admin.gasback.campaigns',
  GasBack: 'admin.gasback',
  CreateGasBackCodes: 'admin.payment.gasback-codes',
  ManualGasBackSync: 'admin.gasback.manual-award',
  TestNotifications: 'admin.system.email',

  // Level based roles for easier admin
  PaymentAdminLevel1: 'admin.level.payment.level1',
  PaymentAdminLevel2: 'admin.level.payment.level1.level2',
  PaymentAdminLevel3: 'admin.level.payment.level1.level2.level3',
  PaymentAdminLevel4: 'admin.level.payment.level1.level2.level3.level4',
  PaymentAdminLevel5: 'admin.level.payment.level1.level2.level3.level4.level5',
};

export const Role = roles;
export const RoleSpec = {};

for (const [k, v] of Object.entries(roles)) {
  RoleSpec[k] = `role:${v}`;
}

export const RoleAction = {
  CreateNewAdminUsers: [Role.PaymentAdminLevel5],
  AdminPaymentLevelUsers: [Role.PaymentAdminLevel5],
  AdminAdminUsers: [],

  ViewAndSearchUsers: [Role.Users, Role.PaymentAdminLevel1],
  ViewAndSearchGroups: [Role.Groups],
};

for (const [, v] of Object.entries(RoleAction)) {
  v.push(Role.Superuser);
}

export const ActionGroups = {
  ViewAdminAccessPage: [
    ...RoleAction.CreateNewAdminUsers,
    ...RoleAction.AdminPaymentLevelUsers,
    ...RoleAction.AdminAdminUsers,
    Role.AdminAdminAccess,
    Role.AnyAdmin,
  ],
};

export function toRoleSpec(...actionsOrRoles) {
  const finalRoles = [];
  actionsOrRoles.forEach((a) => {
    if (Array.isArray(a)) {
      finalRoles.push(...a);
    } else {
      finalRoles.push(a);
    }
  });
  return finalRoles.map(r => `role:${r}`);
}
